export enum MroReason {
    DISCONNECTION_THRESHOLD_REACHED = 'DISCONNECTION_THRESHOLD_REACHED',
    PENDING_FIRST_CONNECTION = 'PENDING_FIRST_CONNECTION',
    FAILED_FIRST_CONNECTION = 'FAILED_FIRST_CONNECTION',
}